import level2Data from "./data/level2.json";
import level3Data from "./data/level3.json";

export const getMenuItem = (menu, slug) => {
    return (
        menu &&
        menu.find((menuItem) => {
            return menuItem.slug === slug;
        })
    );
};

export const getModelPartRoute = (labelText, level1, level2) => {
    if (!labelText || !level1) return null;

    const normalizeName = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, "");
    const normalizedLabel = normalizeName(labelText);
    const matchesLabel = (item) =>
        normalizeName(item.name || "") === normalizedLabel ||
        normalizeName(item.slug || "") === normalizedLabel;

    const currentSectionPrefix = level2
        ? `${level1}/${level2}/`
        : `${level1}/`;
    const matchingPage = Object.entries(level3Data).find(
        ([key, item]) => key.startsWith(currentSectionPrefix) && matchesLabel(item)
    );

    if (matchingPage) {
        const [pageKey, pageData] = matchingPage;
        const landingPage =
            pageData.children?.find((child) => child.slug === "general-information") ||
            pageData.children?.[0];

        return landingPage ? `${pageKey}/${landingPage.slug}` : pageKey;
    }

    const matchingSection = Object.entries(level2Data).find(([key, section]) => {
        if (!key.startsWith(`${level1}/`)) return false;
        return (
            matchesLabel(section) ||
            section.children?.some(matchesLabel)
        );
    });

    if (!matchingSection) return null;

    const [sectionKey, sectionData] = matchingSection;
    const matchingChild = sectionData.children?.find(matchesLabel);
    const organKey = matchingChild
        ? `${sectionKey}/${matchingChild.slug}`
        : sectionKey;
    const organData = level3Data[organKey];

    if (organData) {
        const landingPage =
            organData.children?.find((child) => child.slug === "general-information") ||
            organData.children?.[0];

        return landingPage ? `${organKey}/${landingPage.slug}` : organKey;
    }

    const organPages = Object.entries(level3Data).filter(([key]) =>
        key.startsWith(`${organKey}/`)
    );
    const landingPageEntry =
        organPages.find(([, page]) => page.slug === "general-information") ||
        organPages[0];

    if (!landingPageEntry) return null;

    const [landingPageKey, landingPageData] = landingPageEntry;
    const contentPage =
        landingPageData.children?.find(
            (child) => child.slug === "general-information"
        ) || landingPageData.children?.[0];

    return contentPage ? `${landingPageKey}/${contentPage.slug}` : landingPageKey;
};

export const getModelName = (level2, level3, level4) => {
    if (level2 === "abdomen-and-pelvis") {
        if (["general-information"].includes(level3)) {
            return "general-information"
        } else if (["pancreas", "spleen"].includes(level3)) {
            return "stomach"
        } else if (["stomach"].includes(level3)) {
            if(["anatomical-relationships","ligamentous-attachments"].includes(level4)){
                return "stomach-liver"
            } else if(["blood-supply"].includes(level4)){
                return "stomach-blood-supply"
            }
            return "stomach"
        } else if (["liver"].includes(level3)) {
            return "stomach-liver"
        } else if (["gallbladder"].includes(level3)) {
            return "gallbladder"
        }
    } else if (level2 === "small-bowel") {
        if (["duodenum"].includes(level3)) {
            return "duodenum"
        } else if(["general-information","functions","food-digestion","jejunum-ileum","references"].includes(level3)){
            return "jejunum-ileum"
        }
    } else if (level2 === "digestion") {
        return "colon"
    } else if (level2 === "defecation") {
        return "colon"
    } else if (level2 === "retroperitoneum") {
        if (["general-information", "inferior-vena-cava"].includes(level3)) {
            return "retroperitoneum"
        } else if (["abdominal-aorta"].includes(level3)) {
            return "abdominal-aorta"
        } else if (["kidneys", "adrenal", "ureter", "urinary-bladder", "urethra"].includes(level3)) {
            return "kidneys"
        } else if (["nerves"].includes(level3)) {
            return "nerves"
        }
    } else if (level2 === "abdominal-muscles") {
        if (["general-information"].includes(level3)) {
            return "abdominal-muscles"
        } else if (["hernias"].includes(level3)) {
            return "hernias"
        } else if (["the-inguinal-canal"].includes(level3)) {
            return "the-inguinal-canal"
        }
    } else if (level2 === "musculoskeletal-systems") {
        if (["lumbar-vertebrae"].includes(level3)) {
            return "skeleton"
        } else if (["pelvis"].includes(level3)) {
            return "skeleton-pelvis-ligaments"
        } 
    }
    return "coming-soon"
}
export const getCameraOrbit = (subMenu) => {
    switch (subMenu) {
        case "gallbladder":
            return "4.631318445405346rad 1.7292581465077201rad 66.39224867979487m"
        case "spleen":
            return "-2.615442895858645rad 0.9765714845381677rad 13.55368808478995m"
        case "pancreas":
            return "-0.9623181081077046rad 1.4035714784955802rad 10.585591911503423m"
        default:
            return "90deg 90deg 105%"
    }
}

export const getCameraTarget = (subMenu) => {
    switch (subMenu) {
        case "gallbladder":
            // return "-247.02924002258533m 109.0730847350727m 11.958124887229078m"
        default:
            return "auto auto auto"
    }
}

export const getFieldOfView = (subMenu) => {
    switch (subMenu) {
        case "gallbladder":
            return "22deg"
        default:
            return "30deg"
    }
}

export const getFileName = (fileName) => {
    let fileExtension = fileName.split('.').pop();
    let timeStamp = Math.floor(Date.now() / 1000);
    let newFileName = `${fileName.substr(0, fileName.lastIndexOf(".")).toLowerCase()}-${timeStamp}.${fileExtension}`;
    return newFileName;
}

export const organNames = (level2Data, level1, level2) => {
    let name = level2Data[`${level1}/${level2}`] ? level2Data[`${level1}/${level2}`].version : ""
    switch(level2){
      case "abdomen-and-pelvis":
        return name + " Digestion : Upper Gastrointestinal Tract"
      case "small-bowel" :
        return name + " Digestion : Small Bowel"
      case "digestion" :
        return name + " Digestion : Colon"
      case "defecation" :
        return name + " Defecation : Rectum, Anus"
      case "retroperitoneum" :
        return name + " Retroperitoneum : Vascular, Urology"
      default : 
        return level2Data[`${level1}/${level2}`] ? level2Data[`${level1}/${level2}`].version + " " + level2Data[`${level1}/${level2}`].name : ""
    }
}